import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/api";
import { Modal, Button, Form } from '@themesberg/react-bootstrap';

const EditModal = ({ id, show, handleClose, onAdd }) => {
    const [formData, setFormData] = useState({ name: "", value: "" });

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/option/${id}`)
                .then(response => {
                    setFormData(response.data.data);
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.value) {
            alert('Por favor, completa todos los campos.');
            return;
        }
        axiosInstance.post(`/option/`, formData)
            .then(() => {
                alert("Datos actualizados correctamente");
                onAdd();
                handleClose();
            })
            .catch(error => {
                console.error("Error updating data:", error);
            });
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar Datos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formName">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formValue" className="mt-3">
                        <Form.Label>Valor</Form.Label>
                        <Form.Control
                            type="text"
                            name="value"
                            value={formData.value}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="mt-3">Guardar</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};


export default EditModal;